module.exports = __webpack_public_path__ + "static/media/aparna_she.4d40c53e.jpeg";